import React from 'react'
import { Typography } from 'antd'
import { useIntl } from 'react-intl'
import { EXTEND_TRIAL_GRANTED_DAYS } from '@vacationtracker/shared/constants/survey'

interface ISurveyIntroProps {
  i18nPrefix?: string
}

export function SurveyIntro({ i18nPrefix = 'survey.extendTrial' }: ISurveyIntroProps = {}): JSX.Element {
  const { formatMessage } = useIntl()
  return (
    <div>
      <Typography.Title level={3} style={{ marginBottom: 20, textAlign: 'center' }}>
        {formatMessage({ id: `${i18nPrefix}.intro.title` })}
      </Typography.Title>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 20 }}>
        {formatMessage({ id: `${i18nPrefix}.intro.subtitle` }, { days: EXTEND_TRIAL_GRANTED_DAYS })}
      </Typography.Paragraph>
    </div>
  )
}
